import PropTypes from 'prop-types'
import { idPropType } from '../common/id-prop-type'
import { iso8601PropType } from '../common/iso-8601-prop-type'

/**
 * This is the ObjectTextMessageStatus type definition for the REST model.
 *
 * @typedef {Object} ObjectTextMessageStatus
 * @property {boolean} read - True if the message has been marked as read (either by a Webfleet user or by a driver)
 * @property {ISO8601} [readTime] - Time when this object text message has been read (by a Webfleet user or by a driver)
 * @property {Id} [readUserId] - The ID of the Webfleet user who read this message
 * @property {ISO8601} [receiveTime] - Time when the message has been received by an object
 */
export const objectTextMessageStatusPropType = PropTypes.shape({
    read: PropTypes.bool.isRequired,
    readTime: iso8601PropType,
    readUserId: idPropType,
    receiveTime: iso8601PropType
})
